import { useLocation } from "react-router-dom";
import { DriverApp } from "./DriverApp";
import { MechanicApp } from "./mechanic/App";
import { AuthProvider } from "./mechanic/auth";
import { MechanicTheme } from "./mechanic/MechanicTheme";

export function App() {
  const { pathname } = useLocation();
  const mechanic = pathname === "/mechanic" || pathname.startsWith("/mechanic/");
  // Never mount the other area's auth bootstrap, even while loading.
  return mechanic ? (
    <MechanicTheme><AuthProvider><MechanicApp /></AuthProvider></MechanicTheme>
  ) : <DriverApp />;
}
